import ApiClient from "@/api/clients/ApiClient";

export default class MiscClient extends ApiClient {

  constructor() {
    super({
      headers: {
        Accept: "application/json",
        common: {},
      },
      params: {},
    });
  }

  static of(): MiscClient {
    return new MiscClient();
  }
}
